import script from "./WebRtcVideo.vue?vue&type=script&setup=true&lang=ts"
export * from "./WebRtcVideo.vue?vue&type=script&setup=true&lang=ts"

import "./WebRtcVideo.vue?vue&type=style&index=0&id=8653b314&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8653b314"]])

export default __exports__